<template>
  <div>
    <!-- 城市信息内容 -->
    <section class="city-info">
      <div class="container">
        <div class="section-title">
          <div class="title-decoration"></div>
          <h3>{{ cityName }} City Info</h3>
        </div>
      </div>
    </section>
    <section class="positioning-edge">
      <div class="container">
        <div id="positioning-edge-cards" v-html="textDescribe"></div>

        <!-- 行动按钮 -->
        <div class="action-buttons">
          <button class="btn-primary" @click.prevent="$scrollToRefById('global-contact-us', {}, true)">
            Contact Us for Consultation
          </button>
          <button class="btn-primary" @click.prevent="$goBack()">
            Back 
          </button>
        </div>
      </div>
    </section>

    <StaticData  ref="staticData" :showAnalysis="showAnalysis" />
    <ContactsUs ref="contactsUs" />
  </div>
</template>

<script>
import ContactsUs from '../components/ContactsUs.vue';
import StaticData from '../components/StaticData.vue';

export default {
  name: 'CityInfo',
  components: {
    ContactsUs,
    StaticData
  },
  data() {
    return {
      cityInfos: [],
      cityName: '',
      textDescribe: ``,
      showAnalysis: true
    }
  },
  async mounted() {
    await this.fetchIndustryData();
    // 从路由参数获取数据
    this.cityName = this.$route.params.sign || 'City Information';
    console.log("cityName", this.cityName);
    console.log("data", this.cityInfos.find(city => city.sign === this.cityName));
    // 获取城市信息
    this.textDescribe = this.cityInfos.find(city => city.sign === this.cityName)?.city_describe || 'No information available for this city.';
    // 确保页面在顶部
    this.scrollToTop();
  },
  methods: {
    async fetchIndustryData() {
      try {
          const response = await fetch('/res/config/os/city_resources.json');
          this.cityInfos = await response.json();
      } catch (error) {
          console.error('Failed to fetch industry data:', error);
          // 备用数据
          this.cityInfos = [
          {
            "sign": "ChinaMainland",
            "name_en": "China Mainland",
            "name": "中国大陆",
            "describe": "China Mainland Investment Guide",
            "city_describe": `
              <div class="positioning-edge-card">
                <strong class="title">Positioning & Edge:</strong>
                China Mainland hosts the world’s most comprehensive industrial and supply-chain ecosystem, spanning R&D, core components, manufacturing, logistics, and distribution. Rapid growth in digital economy, smart manufacturing, and new energy is driving differentiated regional specializations (Yangtze River Delta, Greater Bay Area, Beijing–Tianjin–Hebei, and central-western manufacturing corridors)
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Industries & Use-Cases:</strong>
                Advanced manufacturing (EVs, batteries, semiconductors, equipment), digital economy & AI, biopharma & medical devices, renewables & energy storage, cross-border trade & supply-chain finance, and science-to-industry innovation partnerships
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Key Companies: </strong>
                Huawei, Tencent, Alibaba, BYD, CATL, SMIC, BOE/Visionox, State Grid, CRRC
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Opportunities: </strong>
                Ideal for: R&D centers and innovation labs (AI, EV, medtech, industrial IoT)、Regional/global manufacturing & supply-chain hubs、Market entry and localization centers for consumer & industrial brands、Joint ventures and industrial co-development in key clusters & parks
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Quick Stats:</strong>
                Population ~1.4B | World’s leading industrial & consumer system | Clear regional specialization | UTC+8
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Quick Stats:</strong>
                <ul class="custom-list">
                  <li>Semiconductor back-end & automation</li>
                  <li>Regional manufacturing & export hubs</li>
                  <li>Data-center & cloud service deployment</li>
                  <li>Shariah finance structuring</li>
                </ul>
              </div>
              `,
            "icon": "https://res.roadlinkglb.com/pic/os/zstz.jpeg"
          },
          {
            "sign": "Beijing",
            "name_en": "Beijing",
            "name": "北京",
            "describe": "Beijing Investment Guide",
            "city_describe": `
              <div class="positioning-edge-card">
                <strong class="title">Positioning & Edge:</strong>
                Capital of China and national center for politics, diplomacy, science, and strategic innovation with highly concentrated research and policy institutions
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Industries & Use-Cases: </strong>
                AI, ICT, biopharma, finance, aerospace, and new materials supported by clusters such as Zhongguancun and Future Science City
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Key Companies: </strong>
                Baidu, Xiaomi, Lenovo, BOE, BAIC Group, CASC/CASIC aerospace institutions, Tongrentang, Zhongguancun innovation platforms
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Opportunities: </strong>
                Regional HQs, R&D/innovation labs, standard-setting, government & institutional engagement, research partnerships
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Quick Stats:</strong>
                Metro population ~22–24M | High-tier GDP | National policy & innovation hub | UTC+8
              </div>
              `,
            "icon": "https://res.roadlinkglb.com/pic/os/zstz.jpeg"
          },
          {
            "sign": "Shanghai",
            "name_en": "Shanghai",
            "name": "上海",
            "describe": "Shanghai Investment Guide",
            "city_describe": `
              <div class="positioning-edge-card">
                <strong class="title">Positioning & Edge: </strong>
                China’s international finance and global commerce hub with strong rule-of-law and international talent
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Industries & Use-Cases: </strong>
                Finance, ICs, biopharma, intelligent manufacturing, clinical research, anchored by Lujiazui, Zhangjiang, and Lingang
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Key Companies: </strong>
                SPDB, Shanghai Port Group, SAIC, TSMC Shanghai, HLMC, Roche/Pfizer/AstraZeneca China HQs, COMAC, Baowu Steel
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Opportunities: </strong>
                APAC HQs, treasury centers, R&D hubs, supply-chain command centers
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Quick Stats:</strong>
                Metro population ~25–30M | Trillion-scale GDP | YRD global gateway | UTC+8
              </div>
              `,
            "icon": "https://res.roadlinkglb.com/pic/os/zstz.jpeg"
          },
          {
            "sign": "Guangzhou",
            "name_en": "Guangzhou",
            "name": "广州",
            "describe": "Guangzhou Investment Guide",
            "city_describe": `
              <div class="positioning-edge-card">
                <strong class="title">Positioning & Edge: </strong>
                Southern China’s commercial and consumer hub with strong logistics and diversified industry structure
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Industries & Use-Cases: </strong>
                Automobiles/NEVs, healthcare, trade & supply-chain operations, software services, FMCG & food processing
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Key Companies: </strong>
                GAC Group, Vipshop, Guangzhou Pharma, KingMed Diagnostics, Hengjian Healthcare, GBA port & MICE platforms
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Opportunities: </strong>
                Consumer market entry, distribution hubs, biomed partnerships, logistics & trade operations
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Quick Stats:</strong>
                Metro population ~18–20M | GBA core market | Air/port logistics hub | UTC+8
              </div>
            `,
            "icon": "https://res.roadlinkglb.com/pic/os/zstz.jpeg"
          },
          {
            "sign": "Shenzhen",
            "name_en": "Shenzhen",
            "name": "深圳",
            "describe": "Shenzhen Investment Guide",
            "city_describe": `
              <div class="positioning-edge-card">
                <strong class="title">Positioning & Edge: </strong>
                A global tech and advanced manufacturing hub known for rapid iteration and full-stack hardware supply chain capability
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Industries & Use-Cases: </strong>
                Digital economy, AI, telecom equipment, smart devices, EVs, biotech, UAVs & robotics
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Key Companies: </strong>
                Huawei, Tencent, BYD, DJI, Royole, Mindray, Hytera, Shenzhen Capital Group ecosystem
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Opportunities: </strong>
                Hardware prototyping, supply-chain integration, GBA cross-border operations
              </div>
              <div class="positioning-edge-card">
                <strong class="title">Quick Stats:</strong>
                Metro population ~18–20M | GBA innovation core | UTC+8
              </div>
            `,
            "icon": "https://res.roadlinkglb.com/pic/os/zstz.jpeg"
          }
        ];
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    
    downloadReport() {
      // 创建并下载报告
      const element = document.createElement('a');
      const file = new Blob([this.createReportContent()], { type: 'text/plain' });
      element.href = URL.createObjectURL(file);
      element.download = `${this.cityName} Investment Report.txt`;
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  }
}
</script>

<style scoped>
/* PC端样式保持不变 */
.city-info {
  padding-top: 30px;
  background-color: #2444CB;
  width: 100%;
}

.city-info .section-title h3 {
    font-size: 32px;
    color: white;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    padding-bottom: 30px;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}

.card-header {
    display: flex;
    align-items: center;
}

.title-decoration {
    height: 12px;
    width: 60px;
    background-color: #FF9E1B;
    margin-bottom: 16px;
}

/************************************  行动按钮样式  ****************************************/
.action-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  margin: 20px;
}

.btn-primary {
  background-color: #265FFF;
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  min-width: 250px;
  margin: 30px;
}

.btn-primary:hover {
  background-color: #1a4fd8;
}

/************************************  文案样式（PC端）  ****************************************/
::v-deep .positioning-edge-card {
  width: 100%;
  max-width: 1024px;
  margin: auto;
  padding-bottom: 20px;
  font-size: 16px;
  color: #333;
  line-height: 1.7;
  text-align: justify;
}

::v-deep .positioning-edge-card .title {
  display: block;
  font-weight: 700;
  color: #2444CB;
  font-size: 22px;
}

/* 列表样式（PC+移动端通用） */
::v-deep .custom-list {
  margin: 10px 0 0 20px;
  padding: 0;
}

::v-deep .custom-list li {
  margin-bottom: 8px;
  line-height: 1.6;
}

/************************************  响应式样式（平板竖屏 ≤768px）  ****************************************/
@media (max-width: 768px) {
  /* 页面标题适配 */
  .city-info .section-title h3 {
    font-size: 26px;
    padding-bottom: 25px;
  }

  .title-decoration {
    width: 50px;
    height: 10px;
    margin-bottom: 12px;
  }

  /* 卡片样式适配 */
  ::v-deep .positioning-edge-card {
    margin: 15px auto;
    padding: 15px 0; /* 上下内边距，左右继承容器 */
    font-size: 15px;
    line-height: 1.65;
  }

  ::v-deep .positioning-edge-card .title {
    font-size: 20px;
    margin-bottom: 10px;
  }

  /* 按钮适配 */
  .action-buttons {
    margin: 15px 0;
  }

  .btn-primary {
    padding: 14px 25px;
    font-size: 15px;
    min-width: 220px;
    margin: 15px;
  }

  /* 列表适配 */
  ::v-deep .custom-list {
    margin-left: 15px;
  }
}

/************************************  响应式样式（手机 ≤480px）  ****************************************/
@media (max-width: 480px) {
  /* 页面标题适配 */
  .city-info .section-title h3 {
    font-size: 22px;
    padding-bottom: 20px;
    text-align: center; /* 手机端标题居中更友好 */
  }

  .title-decoration {
    width: 40px;
    height: 8px;
    margin: 0 auto 10px; /* 装饰条居中 */
  }

  /* 容器内边距优化（避免手机边缘紧贴） */
  .container {
    padding: 0 15px;
  }

  /* 卡片样式适配 */
  ::v-deep .positioning-edge-card {
    margin: 12px auto;
    padding: 12px 0;
    font-size: 14px;
    line-height: 1.6;
    text-align: left; /* 手机端左对齐比两端对齐更易读 */
  }

  ::v-deep .positioning-edge-card .title {
    font-size: 18px;
    margin-bottom: 8px;
  }

  /* 按钮适配（占满宽度，方便点击） */
  .action-buttons {
    margin: 10px 0;
    gap: 10px;
  }

  .btn-primary {
    padding: 12px 20px;
    font-size: 14px;
    min-width: 100%; /* 手机端按钮占满宽度，点击区域更大 */
    margin: 5px 0;
  }

  /* 列表适配 */
  ::v-deep .custom-list {
    margin-left: 12px;
  }

  ::v-deep .custom-list li {
    margin-bottom: 6px;
    font-size: 13px;
  }
}
</style>